import router from './router'
import i18n from '@/modules/Core/plugins/i18n'
import MainModule from '@/modules/Core'
import UserModule from '@/modules/User'
import AuthModule from '@/modules/Auth'
import CategoryModule from '@/modules/Category'
import ProvinceModule from '@/modules/Province'
import ProductAttributeModule from '@/modules/ProductAttribute'
import ProductModule from '@/modules/Product'
import DiscountModule from '@/modules/Discount'
import CommentModule from '@/modules/Comment'
import PromotionModule from '@/modules/Promotion'
import OrderModule from '@/modules/Order'
import ShippingInquiryModule from '@/modules/ShippingInquiry'
import ShipmentModule from '@/modules/Shipment'
import SliderModule from '@/modules/Slider'
import AboutUsModule from '@/modules/AboutUs'
import RedirectRulesModule from '@/modules/RedirectRules'
import StaticSitemapEntriesModule from '@/modules/StaticSitemapEntries'
import RobotsTxtModule from '@/modules/RobotsTxt'

function flattenModules(modules: Modules): Array<[string, Module]> {
  const entries: Array<[string, Module]> = []

  Object.keys(modules).forEach((moduleKey) => {
    const qualifiedKey = moduleKey
    const module = modules[moduleKey]
    entries.push([qualifiedKey, module])

    if (module.subModules) {
      entries.push(...flattenModules(module.subModules))
    }
  })

  return entries
}

export function registerModules(modules: Modules) {
  const flatModules = flattenModules(modules)

  flatModules.forEach(([moduleKey, module]) => {
    if (module.localization) {
      for (const locale in module.localization) {
        i18n.global.mergeLocaleMessage(
          locale,
          moduleKey === 'main'
            ? module.localization[locale]
            : {
                [moduleKey]: module.localization[locale],
              }
        )
      }
    }

    if (module.router) {
      module.router(router)
    }
  })
}

registerModules({
  user: UserModule,
  main: MainModule,
  auth: AuthModule,
  category: CategoryModule,
  province: ProvinceModule,
  productAttribute: ProductAttributeModule,
  product: ProductModule,
  discount: DiscountModule,
  comment: CommentModule,
  promotion: PromotionModule,
  order: OrderModule,
  shippingInquiry: ShippingInquiryModule,
  shipment: ShipmentModule,
  slider: SliderModule,
  aboutUs: AboutUsModule,
  redirectRules: RedirectRulesModule,
  staticSitemapEntries: StaticSitemapEntriesModule,
  robotsTxt: RobotsTxtModule,
})
